import { Box, Button } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { Auth } from 'aws-amplify';
import FeatherIcon from 'feather-icons-react';
import React from 'react';
import AlertsMenuComponent from './alerts-menu';
import AppPageHeadings from './app-page-headings';
import ProfileMenuComponent from './profile-menu';
import AccessibilityMenuComponent from './accessibility-menu';
import { THEME_MODES } from '../../helpers/constant';
import { useThemeMode } from '../../components/theme';

const CustomHeader = ({ user, userFullName, handleDrawerToggle }) => {
    const { colours } = useThemeMode();
    return (
        <Toolbar
            sx={(theme) => ({
                background: theme.palette.common.white,
                color: theme.palette.common.black,
                height: "100%",
                flexDirection: "row",
                borderBottom: `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? (theme.palette.common.black + '1A') : colours.gray80}`,
            })}
        >
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                sx={{ display: { md: 'none' } }}
                onClick={handleDrawerToggle}
            >
                <FeatherIcon icon="menu" />
            </IconButton>
            <AppPageHeadings />
            {user ? (
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={{ xs: 0, md: 1.5 }}
                >
                    <AccessibilityMenuComponent />
                    <AlertsMenuComponent />
                    <ProfileMenuComponent user={user} userFullName={userFullName} />
                </Box>
            ) : (
                <Button
                    variant="contained"
                    onClick={() => Auth.federatedSignIn()}
                >
                    Login
                </Button>
            )}
        </Toolbar>
    );
};

export default CustomHeader;